<template>
  <div>
    <!--<ul class="uls">-->
      <!--<li v-for="(item,val) in menus" @click="tabinfo(val)" :class="{'active':index==val}">{{item}}</li>-->
    <!--</ul>-->
    <div v-if="index==0">
      <div class="container" v-if="containerList.length>0">
        <i-videolist :video_newest="containerList"></i-videolist>

        <p class="end"><span> </span> THE END <span> </span></p>
      </div>
      <div class="none" v-if="containerList.length<1" >
        <img src="../../assets/images/nonelist.png" alt="" >
        <p>暂无收藏</p>
      </div>
    </div>
    <div v-if="index==1">
      <!--columnList-->
      <div class="container">
        <div class="item_list">
          <div class="liveswill"
               v-for="(item,index) in columnList"
               :key="'liveswill'+index">
            <div class="con"
                 @click="toDetails(item.colId)">
              <p class="item_title">
                <span class="title_name">{{item.egName}}频道</span>
                <span class="title_time">{{getTimes(item.colCreateDt)}}</span>
              </p>
              <img class="con_images"
                   :src="item.colThumbnailUrl"
                   alt=""
                   v-if="item.colThumbnailUrl">
              <img class="con_images"
                   src="../../assets/images/default.png"
                   alt=""
                   v-else>
              <div class="con_right">
                <p class="con_title">{{item.colTitle}}</p>
                <div>
                  <p class="con_author">{{item.entity.eName}}</p>
                  <div class="con_bt">
                    <span>参会人数：{{item.orderNum}}</span>
                    <span  class="con_bt_r" v-if="item.colIsCharge*1&&!item.buyed">
                      <span>¥{{item.colFees}}</span>
                    </span>
                    <span class="con_bt_r"
                          style="font-size: 0.26rem"
                          v-if="item.colIsCharge*1&&item.buyed">
                      已购
                    </span>

                    <span class="con_bt_r"
                          style="font-size: 0.26rem"
                          v-if="item.colIsCharge*1==0">
                      免费
                  </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="none" v-if="columnList.length<1" >
        <img src="../../assets/images/nonelist.png" alt="" >
        <p>暂无收藏</p>
      </div>

    </div>


  </div>
</template>
<script>
import AppSetting from '../../AppSetting';
import loginService from '../../plugin/extendFn/loginService';
  import iVideolist from '../container/videoList'
  export default {
    data() {
      return {
        menus:[
          '单课',
          '专栏'
        ],
        containerList:[//直播列表内容
        ],
        wxuser:null,
        columnList:null,
        // index:0,
      }
    },
    props: ['index'],
    methods: {
      login () {
            loginService.login(this.$router)
            .then(loginUser=>{
              this.wxuser=loginUser;
            })
          },
      async toDetails (id) {
        if (await loginService.isNotLogin()) {
          this.login();
        } else {
          this.wxuser=await loginService.getLoginUser()

          this.$router.push({
            name: "colDetails",
            query: { type: "column", colId: id }
          });
        }
      },
      getTimes(value){
        return new Date(value).Format("yyyy.MM.dd hh:mm");
      },
      getList(){
        this.$postHttp(AppSetting.baseUrl + '/student/collection',{id:this.wxuser.uId}).then((res)=>{
          if(res.data.code==0){
            this.containerList = res.data.list;
            this.columnList = res.data.columnList;
          }
        })
      },
      tabinfo(index){
        this.index=  index;
      }
    },
    computed: {},
    components:{
      iVideolist
    },
    async mounted() {
      this.wxuser = await loginService.getLoginUser();

      this.getList();
    }
  }
</script>
<style scoped lang="scss">
  .item_title {
    font-size: 12px;
    margin-bottom: 10px;
    margin-top: 3px;
    display: flex;
    justify-content: space-between;
    .title_name {
      color: #666666;
      width: 110px;
      display: inline-block;
      display: -webkit-box;
      -webkit-box-orient: vertical; /*设置弹性盒模型子元素的排列方式*/
      -webkit-line-clamp: 1; /*限制文本行数*/
      /*white-space: nowrap;      !*超出的空白区域不换行*!*/
      overflow: hidden; /*超出隐藏*/
      text-overflow: ellipsis; /*文本超出显示省略号*/
    }
    .title_time {
      color: #999999;
    }
  }
  .con_bt{
    font-size: 14px;
    color: #999999;
    overflow: hidden;
    line-height: 30px;
  }
  .con_bt_r{
    font-size: 16px;
    float: right;
    color: #f00000;
  }
  .uls{
    position: relative;
    margin-top: 10px;
    display: flex;
    width: 1280px;
    min-width: 1280px;
    border-bottom: 1px solid #E6E6E6;
    color: #666666;
    align-items: center;
    z-index: 1;
    li{
      width: 200px;
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      cursor: pointer;
    }
    li:nth-of-type(2){
      /*border-left: 1px solid #E6E6E6;*/
    }
    .active{
      color: #05a2ff;
      border-bottom: 1px solid #05a2ff;
    }
  }

  .container{
    min-width: 1280px;
    width: 1280px;
    margin-bottom: 0.98rem;
  }
  .liveswill {
    border: 1px solid #e6e6e6;
    height: 280px !important;
    border-radius: 5px;
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    -ms-flex-direction: column;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    flex-direction: column;
    width: 232px;
    cursor: pointer;
    padding: 0 10px;

    float: left;
    margin: 24px 24px 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -ms-flex-pack: justify;
    -webkit-box-pack: justify;
    justify-content: flex-start;
    .con {
      margin-top: 6px;
    }
    .con_images {
      width: 212px !important;
      height: 134px !important;
      border-radius: 5px !important;
    }
    .con_title {
      font-size: 14px !important;
      color: #333 !important;
      line-height: 18px !important;
      height: 39px !important;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical; /*设置弹性盒模型子元素的排列方式*/
      -webkit-line-clamp: 2; /*限制文本行数*/
      /*white-space: nowrap;      !*超出的空白区域不换行*!*/
      overflow: hidden; /*超出隐藏*/
      text-overflow: ellipsis; /*文本超出显示省略号*/
    }

    .con_author {
      font-size: 12px !important;
      font-weight: 300 !important;
      color: #666666 !important;
      min-height: 14px !important;
      margin-top: 5px !important;
    }
    .last {
      padding: 0px !important;
      box-sizing: border-box !important;
      margin-top: 6px !important;
      height: 20px;
    }
  }
  .live_type{
    f-webkit-box-flex: 1;
    -ms-flex: 1 1;
    flex: 1 1;
    font-size: 26px;
    font-weight: 500;
    color: #007EFF;
  }
  .none{
    width: 100%;
    min-height: 260px;
    box-sizing: border-box;
    text-align: center;
    img{
      width: 100px;
      display: inline-block;
      margin:  80px auto 0px;
      /*width: 100%;*/
    }
    p{
      font-size: 16px;
      color: #999999;
      text-align: center;
    }
  }
  .live_type{
    margin-top: 24px;
    margin-bottom: 0px;

  }
  .container {
    /*background:#F4F5F4;*/
    /*min-height: 100vh;*/
    /*padding: 0.2rem 0.3rem;*/
    overflow: hidden;
    box-sizing: border-box;
    /*margin-bottom: 1.18rem;*/

    .end{
      text-align: center;
      color: #DBDBDB;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 33px;
      span{
        display: inline-block;
        overflow: hidden;
        width: 100px;
        vertical-align: center;
        border-top: 1px solid #DBDBDB;
      }
      span:nth-of-type(1){
        margin-right: 18px;
      }
      span:nth-of-type(2){
        margin-left: 18px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/me/collection.vue